import { Collapse } from 'antd'
import React from 'react'

export const PeopleAlsoAsk = () => (
  <Collapse bordered={false} defaultActiveKey={['0']}>
    <Collapse.Panel header="จะได้รับเหรียญเมื่อไร?" key="1">
      <p>
        <span>
          ทางเราจะจัดส่งเหรียญเเละเสื้อ(สำหรับคนที่ซื้อเพิ่ม) หลังสิ้นสุดกิจกรรม
          ภายใน 10 วันทำการ ผ่านไปรษณีย์ไทยเเบบลงทะเบียน
        </span>
      </p>
    </Collapse.Panel>
    <Collapse.Panel header="สามารถส่งผลการวิ่ง/เดินได้ที่ไหน?" key="2">
      <p>
        คุณสามารถส่งรูปผลการวิ่ง/เดินได้ที่ลิ้งค์นี้ (
        <a href="/submit-run" target="_blank" rel="noopen">
          กด
        </a>
        )
      </p>
    </Collapse.Panel>
  </Collapse>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PeopleAlsoAsk/index.js